module.exports = __webpack_public_path__ + "img/36_BF14_need_exercise.99c76735.jpg";